import { CustomSelectFieldProps, SelectField } from 'components/form'
import { TipoMaterialParedeEnum } from 'graphql/types.generated'

import { tipoMaterialParedeEnumRecord } from './condicoes-moradia-model'

type TipoMaterialParedeSelectFieldProps = CustomSelectFieldProps<TipoMaterialParedeEnum>

export function TipoMaterialParedeSelectField(props: TipoMaterialParedeSelectFieldProps) {
  return <SelectField<TipoMaterialParedeEnum> items={items} itemToString={itemToString} {...props} />
}

const items = Object.values(TipoMaterialParedeEnum)
const itemToString = (item: TipoMaterialParedeEnum) => item && tipoMaterialParedeEnumRecord[item]
